import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ClientCommentsEndpoints as Endpoints,
  type AddClientCommentRequest,
  type AddClientCommentResponse,
  type DeleteClientCommentRequest,
  type DeleteClientCommentResponse,
  type EditClientCommentRequest,
  type EditClientCommentResponse,
  type UnpinClientCommentRequest,
  type UnpinClientCommentResponse,
} from '@app/api/ClientComments/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';

export const clientCommentsApi = createApi({
  reducerPath: 'clientCommentsApi',
  baseQuery: createApiBaseQuery('/Client/Comments'),
  endpoints: ({ mutation }) => ({
    [Endpoints.AddClientComment]: mutation<
      AddClientCommentResponse,
      AddClientCommentRequest
    >({
      query: ({ data, ...params }) => ({
        url: 'Add',
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.EditClientComment]: mutation<
      EditClientCommentResponse,
      EditClientCommentRequest
    >({
      query: (params) => ({
        url: 'Edit',
        method: Methods.PUT,
        params,
      }),
    }),
    [Endpoints.DeleteClientComment]: mutation<
      DeleteClientCommentResponse,
      DeleteClientCommentRequest
    >({
      query: (params) => ({
        url: 'Delete',
        method: Methods.DELETE,
        params,
      }),
    }),
    [Endpoints.UnpinClientComment]: mutation<
      UnpinClientCommentResponse,
      UnpinClientCommentRequest
    >({
      query: (params) => ({
        url: 'Unpin',
        method: Methods.POST,
        params,
      }),
    }),
  }),
});

export const {
  useAddClientCommentMutation,
  useEditClientCommentMutation,
  useDeleteClientCommentMutation,
  useUnpinClientCommentMutation,
} = clientCommentsApi;
